import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import threadInfo from "./modules/threadInfo";
import posts from "./modules/posts";
import pages from "./modules/pages";
import feeds from "./modules/feeds";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store({
  modules: {
    auth,
    threadInfo,
    posts,
    pages,
    feeds
  },
  strict: debug
});

export default store;
